<template>
    <search-result-list class="trip-pattern-list">
        <slot>
            <div class="py-4 d-flex flex-column align-center">
                <p class="text-h6 font-weight-bold text-black mb-3">{{ t('trips.resources.noResultsTitle') }}</p>
                <p class="text-body-1">{{ t('trips.resources.noResultsSubtitle') }}</p>
            </div>
        </slot>
        <slot name="append" />
    </search-result-list>
</template>

<script setup lang="ts">
import { SearchResultList } from '@/features/common/components';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
